<script>
    import {map} from 'lodash';
    import {mapState,mapActions } from 'vuex';
    import {closestSelector} from "../../../commonjs/helpers";
    import {createNodeFromString} from "../../../commonjs/utils/NodeHandler";
    import HeightMixin from "../../../author/pagesbuilder/mixins/HeightMixin";
    import AlignmentMixin from "../../../author/pagesbuilder/mixins/AlignmentMixin";
    import BackgroundMediaMixin from "../../../author/pagesbuilder/mixins/BackgroundMediaMixin";
    import SectionListenersMixin from "../../../author/pagesbuilder/mixins/SectionListenersMixin";
    import {SectionsListConfig} from "../../../author/pagesbuilder/components/editing-sideform/config/SectionsListConfig";

    export default {
        name: "Section",
        mixins:[
            BackgroundMediaMixin,
            AlignmentMixin,
            HeightMixin,
            SectionListenersMixin,
        ],
        data () {
            return {
                sectionNode: null, //section node that the component is in charge of
                sectionTemplateId: "", //section html attribute with the template id of the section
                nestedComponentIds: [], // array with the ids of all the dynamic components that exist inside the section
                nestedElementIds: [],// array with the ids of all the elements that exist inside the section
                sectionType: "section",
                givesContextToChildren: true,
                myIdName : "sectionId"
            }
        },
        props : {
            registrationData: {
                type: Object
            }
        },
        computed: {
            ...mapState('products', [
                'courses',
                'bundles',
                'subscriptions'
            ]),
            ...mapState('sections',[
                'sectionsData'
            ]),
            ...mapState('components',[
                'componentsData',
            ]),
            ...mapState([
                'serverImg'
            ]),
            myNode () {
                return this.sectionNode;
            },
            myNodeType () {
                return this.sectionType;
            },
            myState () {
                return this.sectionStates[this.sectionId] ? this.sectionStates[this.sectionId] : {};
            },
            myData () {
                return this.sectionData;
            },
            myId () {
                return this.sectionId;
            },
            getDefaultDataStructure () {
                return {
                    sectionType: this.sectionType,
                    sectionId: this.sectionId,
                    styles: null,
                    anchor: "",
                    videoMediaData: {
                        params: {
                            autoplay : true,
                            mute : true,
                            loop : false,
                            popup : false
                        }
                    },
                    imageMediaData: null,
                    embedMediaData: null,
                    selectedMedia: "",
                    version: "v1",
                    responsiveHeightClass: {
                        'desktop': '',
                        'tablet-portrait': '',
                        'tablet-landscape': '',
                        'smartphone-portrait': '',
                        'smartphone-landscape': ''
                    },
                    responsiveAlignmentClass: {
                        'desktop': '',
                        'tablet-portrait': '',
                        'tablet-landscape': '',
                        'smartphone-portrait': '',
                        'smartphone-landscape': ''
                    },
                    itemVisibilitySettings: null
                }
            },
            sectionData () {
                return this.sectionsData[this.sectionId] ? this.sectionsData[this.sectionId] : {};
            },
            sectionOutdated () {

                if (this.sectionData && this.mySectionConfigData && this.sectionData.version && this.mySectionConfigData.version) {
                    return parseInt(this.sectionData.version) < parseInt(this.mySectionConfigData.version);
                }

                if (this.sectionData && this.mySectionConfigData && !this.sectionData.version && this.mySectionConfigData.version && this.mySectionConfigData.version !== "v1") {
                    return true;
                }

                return false;
            },
            mySectionConfigData () {
                let mySectionConfigData = {};
                let sectionTemplateId = this.sectionTemplateId;

                if (sectionTemplateId) {
                    map(SectionsListConfig , (categoryData,categoryName) => {
                        categoryData.sections.find( (sectionConfigData,index) => {
                            if (sectionConfigData.selector && sectionConfigData.selector === sectionTemplateId) {
                                mySectionConfigData = sectionConfigData;
                            }
                        })
                    })
                }

                return mySectionConfigData;
            }
        },
        created () {
            this.sectionCreated();
        },
        methods: {
            ...mapActions('sections',[
                'addSectionState',
                'editRegisteredSection',
                'setSectionData',
            ]),
            showImage () {
                this.toggleEmbedWrapperDisplay(false);
                this.toggleVideoWrapperDisplay(false);
                this.toggleBgImageDisplay(true);
            },
            showColor () {
                this.toggleEmbedWrapperDisplay(false);
                this.toggleVideoWrapperDisplay(false);
                this.toggleColorOnlyDisplay(true);
            },
            showVideo () {
                this.toggleEmbedWrapperDisplay(false);
                this.toggleVideoWrapperDisplay(true);
                this.toggleBgImageDisplay(false);
            },
            insertVideo (videoWrapper,frame) {
                let frameRatioWrapper = this.getBgFrameRatioWrapper();

                if (!frameRatioWrapper) {
                    frameRatioWrapper = document.createElement('div');
                    frameRatioWrapper.classList.add("js-background-frame-wrapper");
                    frameRatioWrapper.setAttribute("style","position:relative;height:100%;overflow:hidden");
                    frameRatioWrapper.appendChild(frame);
                    videoWrapper.appendChild(frameRatioWrapper);
                } else {
                    this.removeVideo(videoWrapper);
                    frameRatioWrapper.appendChild(frame);
                }

                this.$nextTick(function () {
                    this.backgroundFrameDimensions(frame);
                }.bind(this));
            },

            getVideoUrl () {
                if (!this.myData?.videoMediaData?.video) {
                    return "";
                }

                if (this.myData.videoMediaData.video.type === "vimeo") {
                    return this.createVimeoUrl(this.myData.videoMediaData.video, this.myData.videoMediaData.params, false);
                } else if (this.myData.videoMediaData.video.type === "wistia") {
                    return this.createWistiaUrl(this.myData.videoMediaData.video, this.myData.videoMediaData.params, false);
                }

                return "";
            },

            getBgFrameRatioWrapper () {
                let videoWrapper = this.getVideoWrapper();

                if (videoWrapper) {
                    return videoWrapper.querySelector(".js-background-frame-wrapper");
                }

                return null;
            },
            getEmbedWrapperParent(node){
                return node || this.myNode;
            },
            editEmbedWrapperStyles(embedWrapper) {
                embedWrapper.classList.add("lw-embed-wrapper");
                embedWrapper.classList.add("learnworlds-element");
                embedWrapper.style.overflow = "hidden";
            },

            backgroundFrameDimensions (frame) {

                let $sectionNode = $(this.sectionNode);
                //TODO CREATE OBJECT FOR EACH SECTION
                this.sectionHeight = $sectionNode.outerHeight();
                this.sectionWidth = $sectionNode.outerWidth();
                this.setDynamicDimensions(frame);

                this.resizeListenerTimeoudId = window.setInterval( function () {
                    let newH = $sectionNode.outerHeight();
                    let newW = $sectionNode.outerWidth();

                    if (this.sectionHeight !== newH || this.sectionWidth !== newW) {

                        this.setDynamicDimensions(frame)
                        this.sectionHeight = newH;
                        this.sectionWidth = newW;
                    }

                }.bind(this),100);

            },
            getVideoWrapper (wrapper) {
                //we must find the section video wrapper , if we just querySelector for the class we might find a video wrapper that belongs to another element
                // so we have to check all wrappers and make sure they are not nested inside another element

                if (!wrapper) {
                    wrapper = this.myNode;
                }

                let videoWrappers = wrapper.querySelectorAll(".js-video-wrapper");
                let sectionVideoWrapper = null;

                for ( let index in videoWrappers ) {
                    if (!videoWrappers.hasOwnProperty(index)) {
                        continue;
                    }

                    let videoWrapper = videoWrappers[index];


                    let closestNodeType = closestSelector(videoWrapper,this.classSelectors.nodeWithDataTypeAttribute); //look for data-node-type attribute to make sure its not nested

                    //if no other data-node-type attribute exists in parents then its a section video
                    if (!closestNodeType) {
                        sectionVideoWrapper = videoWrapper;
                    }
                }

                if (!sectionVideoWrapper) {
                    sectionVideoWrapper = document.createElement('div');
                    sectionVideoWrapper.classList.add(".js-video-wrapper");
                }

                return sectionVideoWrapper;
            },

            setDynamicDimensions (frame) {

                let $sectionNode = $(this.sectionNode);
                let videoWrapper= this.getVideoWrapper();
                let sectionHeight = $sectionNode.outerHeight();
                let sectionWidth = $sectionNode.outerWidth();

                videoWrapper.style.height = sectionHeight + "px";
                videoWrapper.style.position = "absolute";
                videoWrapper.style.width = "100%";
                videoWrapper.style.top = "0";
                videoWrapper.style.left = "0";
                frame.style.top = "50%";
                frame.style.left = "50%";
                frame.style.transform = "translate(-50%,-50%)";
                frame.style.position = "absolute";
                frame.style.minWidth = 1.777778 * sectionHeight + "px";

                frame.style.minHeight = sectionHeight + "px";
                frame.style.height = (0.5625 * sectionWidth) + "px";
                frame.style.width = ( 1.7777778 * sectionHeight ) + "px";

                if (sectionHeight > sectionWidth) {
                    let additionalRatio = sectionHeight / sectionWidth < 1.777778 ? 1.777778 : sectionHeight / sectionWidth;
                    this.applyInlineStyle( { styleProp: "height", value : 0.5625 * additionalRatio * sectionHeight , valuePostFix : "px"} , frame);
                    this.applyInlineStyle( { styleProp: "width" , value : 1.777778 * sectionHeight * additionalRatio , valuePostFix : "px"} , frame);


                } else {
                    this.applyInlineStyle( { styleProp: "height", value : sectionWidth * 0.5625 , valuePostFix : "px"} , frame);
                    this.applyInlineStyle( { styleProp: "width" , value : 1.777778 * sectionWidth , valuePostFix : "px"} , frame);
                }

            },
            sectionCreated () {
                this.handleRegistration().then( () => {
                    this.sectionCreationStartCallback();
                    this.acquireSectionData();
                    this.addSectionState({
                        sectionId: this.sectionId,
                        state: this
                    });
                    this.createSectionListeners();
                    this.createComponentListeners();
                    this.sectionCreationCompleteCallback();
                });
            },
            acquireSectionData () {
                if (typeof this.sectionsData[this.sectionId] === "undefined") {
                    this.changeMyData(copyJson(this.getDefaultDataStructure));
                } else if (!Object.keys(this.getDefaultDataStructure).every(key => typeof this.myData[key] !== "undefined") ) {

                    let updatedValues = {};

                    Object.keys(this.getDefaultDataStructure).forEach( key => {
                        let defaultValue = this.getDefaultDataStructure[key];
                        if (typeof this.myData[key] === "undefined") {
                            updatedValues[key] = defaultValue;
                        }
                    })

                    this.changeMyData(updatedValues);
                }
            },
            createComponentListeners () {
                this.$on("componentRendered",  (eventData) =>  {
                    this.nestedComponentRendered(eventData);
                });
            },
            bindNestedComponent (stateThatTriggeredBubbling) {
                if (!this.nestedComponentIds.includes(stateThatTriggeredBubbling.componentId)) {
                    this.nestedComponentIds.push(stateThatTriggeredBubbling.componentId);

                    if (this.givesContextToChildren) {
                        stateThatTriggeredBubbling.setContext(this);
                        stateThatTriggeredBubbling.componentContextBindingFinished();
                    }
                }
            },
            bindNestedElement (stateThatTriggeredBubbling) {
                if (!this.nestedElementIds.includes(stateThatTriggeredBubbling.elementId)) {
                    this.nestedElementIds.push(stateThatTriggeredBubbling.elementId);

                    if (this.givesContextToChildren) {
                        stateThatTriggeredBubbling.setContext(this);
                        stateThatTriggeredBubbling.elementContextBindingFinished();
                    }
                }
            },
            handleRegistration () {
                //tempId is used either when parsing DOM and finding a section without an ID or when inserting new section from the sectionList
                if (this.registrationData.tempId) {
                    return this.handleRegistrationWithTempId();
                } else if (this.registrationData.sectionId) {
                    return this.handleRegistrationWithExistingId();
                }
            },
            createSectionId () {
                return "section_" + window.createTimeID();
            },
            changeMyData (newData) {
                if (!newData.sectionId) {
                    newData.sectionId = this.sectionId;
                }
                this.setSectionData(newData);
            },
            handleRegistrationWithExistingId () {
                return new Promise( (resolve,reject) => {
                    this.sectionNode = this.registrationData.sectionNode;
                    this.sectionId = this.sectionNode.id;
                    this.sectionTemplateId = this.registrationData.sectionTemplateId;
                    resolve();
                })
            },
            handleRegistrationWithTempId () {
                //when handling the tempId we need to create a new sectionId which we are going to init the element with and also change the registrationData to include the new Id there and remove the temp
                //also check if the tempId was used for a newly inserted element or an element that exists in the DOM
                let newSectionId = this.createSectionId();

                this.editRegisteredSection({
                    action: "replaceTempId",
                    tempId: this.registrationData.tempId,
                    sectionId: newSectionId
                })

                //when a section is found as a node without an id
                if (this.registrationData.sectionNode) {

                    return new Promise( (resolve,reject) => {
                        this.sectionNode = this.registrationData.sectionNode;
                        this.sectionNode.id = newSectionId;
                        this.sectionId = newSectionId;
                        this.sectionTemplateId = this.registrationData.sectionTemplateId;
                        resolve();
                    })

                } else if (this.registrationData.liquidFile){ //when we have no node but a reference to a liquid file to render
                    let data = {};

                    //for sections that are initialised in pages with context ( product pages , after login page etc)
                    if (this.registrationData.context) {
                        return this.getDataForContext(this.registrationData.context).then((contextData) => {
                            return this.acquireSectionTemplate(this.registrationData.liquidFile, contextData).then(this.insertRenderedContent.bind(null,newSectionId));
                        });
                    }

                    return this.acquireSectionTemplate(this.registrationData.liquidFile, data).then(this.insertRenderedContent.bind(null,newSectionId));
                }
            },
            insertRenderedContent (newSectionId,sectionHtml) {
                let newSectionNode = createNodeFromString(sectionHtml.trim());
                newSectionNode.id = newSectionId;
                this.sectionId = newSectionNode.id;
                this.sectionNode = newSectionNode;
                this.sectionTemplateId = this.registrationData.sectionTemplateId;

                this.insertSectionValidation(newSectionNode);
                this.scrollInView();
                this.handleSelection(true);
                this.initComponentsManager(this.sectionNode);
                this.initElementsManager(this.sectionNode);

            },
            nestedComponentRendered (eventData) {},
            sectionCreationStartCallback () {},
            sectionCreationCompleteCallback () {}
        }
    }
</script>
